import { Button, Icon, useDisclosure } from '@chakra-ui/react';
import { BiPin } from 'react-icons/bi';

import { WidgetWizard } from '../WidgetWizard/WidgetWizard';

export const CreateWidgetFromTable = ({ initialValue }: { initialValue?: Partial<DashboardWidgetDefinition> }) => {
    const { isOpen, onOpen, onClose } = useDisclosure();

    return (
        <>
            <Button leftIcon={<Icon as={BiPin} />} size="sm" onClick={onOpen} variant="outline">
                Create widget
            </Button>
            {isOpen && <WidgetWizard onClose={onClose} initialValue={initialValue} showImport={false} />}
        </>
    );
};
